// extracted by mini-css-extract-plugin
export default {"popoverContent":"style_popoverContent__+Gp7N","popover":"style_popover__rvc8X","bordered":"style_bordered__0RK4z"};